(function () {
    'use strict';
    var ImmunizationsBaseCtrl = function (autoInit) {
        return function ($q, $scope, $stateParams, MyChartService, DateUtilities, $modal, PatientPortalStorageRepository) {
            $scope.loadingStartup = true;
            $scope.loadingVaccineCard = false; // starts as false due to mobile view
            $scope.model = {
                PatientImmunizations: null,
                ImmunizationsExist: '',
                SelectedVaccineCard: '',
                VaccineCardList: {
                    Adult: '',
                    Pediatric: '',
                    Misc: ''
                }
            };

            var activePatient = PatientPortalStorageRepository.getActivePatient();
            var loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };

            function initialize() {
                $scope.loadingStartup = true;
                $scope.removeHttpError();
                var activePatientId = PatientPortalStorageRepository.getActivePatient().id;

                var getDetailsPromise = MyChartService.getDetails(activePatientId);
                var getMyChartConfigPromise = MyChartService.getMyChartConfig();

                $q.all([getDetailsPromise, getMyChartConfigPromise]).then(function (results) {
                    var details = results[0];
                    var data = results[1];

                    $scope.model.VaccineCardList.Adult = {
                        Name: 'Adult',
                        Id: data.ViewImmunizations.Config.Adult,
                    };
                    $scope.model.VaccineCardList.Pediatric = {
                        Name: 'Pediatric',
                        Id: data.ViewImmunizations.Config.Pediatric,
                    };
                    if (data.ViewImmunizations.Config.Misc) {
                        $scope.model.VaccineCardList.Pediatric = {
                            Name: 'Misc',
                            Id: data.ViewImmunizations.Config.Misc,
                        };
                    }
                    var patientAge = DateUtilities.getPersonAge(new Date(details.DateOfBirth).toLocaleDateString()).age;
                    var vaccineCardType = (patientAge > 18) ? $scope.model.VaccineCardList.Adult : $scope.model.VaccineCardList.Pediatric;
                    loadVaccineCard(vaccineCardType);
                    auditImmunization(reportRequestDto);
                })
                .catch(function (response) {
                    $scope.addHttpError(response);
                })
                .finally(function () {
                    $scope.loadingStartup = false;
                });
            }

            function loadVaccineCard(vaccineCardType) {
                $scope.loadingVaccineCard = true;
                $scope.removeHttpError();
                $scope.model.SelectedVaccineCard = vaccineCardType;
                MyChartService.getImmunizations(activePatient.id, vaccineCardType.Id)
                    .then(function (data) {
                        $scope.model.PatientImmunizations = _.forEach(data.Results, function (vaccineTypeList) {
                            if (vaccineTypeList.Immunizations.length === 0) {
                                vaccineTypeList.Immunizations.push({
                                    Name: '',
                                    AdministeredDate: null,
                                    Details: ''
                                });
                            } else {
                                $scope.model.ImmunizationsExist = true;
                            }
                        });
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loadingVaccineCard = false;
                    });
            }

            function auditImmunization(reportRequestDto) {
                MyChartService.auditImmunizationLogging(reportRequestDto);
            }

            function viewModal() {
                $scope.modalPrint = true;
                var modalInstance = $modal.open({
                    templateUrl: '/mychart/views/modals/immunizationModal.html',
                    controller: 'ImmunizationModalCtrl',
                    scope: $scope,
                    resolve: {
                        patientImmunizations: function () {
                            return $scope.model.PatientImmunizations;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.modalPrint = false;
                });
            }

            $scope.tileState = {
                isCollapsed: undefined
            };
            $scope.toggleState = function toggleState() {
                if ($scope.tileState.isCollapsed === undefined) {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            };

            $scope.auditImmunzation = auditImmunization;
            $scope.loadVaccineCard = loadVaccineCard;
            $scope.viewModal = viewModal;

            if (autoInit) {
                initialize();
            }
        };
    };
    //The desktop controller automatically loads the data; the mobile one waits until the user expands that section
    var ImmunizationsCtrl = new ImmunizationsBaseCtrl(true);
    var ImmunizationsMobileCtrl = new ImmunizationsBaseCtrl(false);
    angular.module('mychart').controller('ImmunizationsCtrl',
        ['$q', '$scope', '$stateParams', 'MyChartService', 'DateUtilities', '$uibModal', 'PatientPortalStorageRepository',
            ImmunizationsCtrl]);
    angular.module('mychart').controller('ImmunizationsMobileCtrl',
        ['$q', '$scope', '$stateParams', 'MyChartService', 'DateUtilities', '$uibModal', 'PatientPortalStorageRepository',
            ImmunizationsMobileCtrl]);
})();